import { render, staticRenderFns } from "./TypeChecklistItem.vue?vue&type=template&id=039da560&"
import script from "./TypeChecklistItem.vue?vue&type=script&lang=js&"
export * from "./TypeChecklistItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports